module.exports = __webpack_public_path__ + "static/images/recipient-msd.2V3ckyq.svg";